import { useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { truncateString, stringLengthMax } from '../../utils/utilFunctions';

import StyledWrapper from './style';

import Tooltip from '@mui/material/Tooltip';
import AccordionDetails from '@mui/material/AccordionDetails';

import AppProcessIcon from '../../assets/customIcons/applicantProcess.jsx';
import LaunchIcon from '@mui/icons-material/Launch';
import ReviewContent from '../../assets/customIcons/reviewFormIcon';
import SubmissionStageIcon from '../../assets/customIcons/submissionStageIcon';
import ReviewFormIcon from '../../assets/customIcons/reviewForm.jsx';
import ReviewStageIcon from '../../assets/customIcons/reviewStageIcon.jsx';
import AppFormIcon from '../../assets/customIcons/appFormIcon';
import { getStatusColor } from '../../utils/utilFunctions';
import FormsDropdown from './FormsDropdown';
import VerticalNavLink from './VerticalNavLink';

const VerticalNavigation = ({ data, customInnerWidth, baseURL }) => {
	const location = useLocation();
	const navigate = useNavigate();
	const mainContainer = useRef();

	const pathArray = location?.pathname?.split('/');
	const mainPath = baseURL || pathArray?.slice(0, -1);
	const activeLink = pathArray[pathArray?.length - 1]?.replaceAll('%20', ' ');

	const [expanded, setExpanded] = useState('all');

	const goToTab = (page) => {
		if (page?.includes('http')) {
			window.open(page, '_blank');
		} else {
			navigate(`${baseURL || mainPath?.join('/')}/${page.toLowerCase()}${location?.search}`);
		}
	};

	return (
		<StyledWrapper.Container
			customInnerWidth={customInnerWidth}
			ref={mainContainer}
			expanded={expanded === `Application`}
		>
			{data?.map((item) => {
				const url = window.location.href;
				const isActive = item?.id === activeLink || url.includes(`${item?.id}/details`);
				let itemTitle = item?.title ? item.title : '';

				return item?.children ? (
					<StyledWrapper.DropdownContainer
						expanded={expanded === item?.title || expanded === 'all'}
						TransitionProps={{ unmountOnExit: true }}
						className={'applicationProcess'}
						initialDropdown={true}
						id={'initial-dropdowncontainer'}
						activeOverview={isActive}
					>
						<StyledWrapper.CustomAccordionSummary
							aria-controls={`applicationProcess-content`}
							id={`applicationProcess-header`}
							sx={{
								maxWidth: '100%',
								minHeight: '24px!important',
								paddingBottom: expanded && '10px!important'
							}}
						>
							{expanded ? (
								<StyledWrapper.MinusIcon onClick={() => setExpanded(false)} />
							) : (
								<StyledWrapper.PlusIcon onClick={() => setExpanded(item?.title)} />
							)}
							<AppProcessIcon
								isActive={true}
								customColor={getStatusColor(item?.status)}
								isCurrentStage={item?.is_current_stage}
							/>
							<Tooltip
								title={itemTitle.length > stringLengthMax ? itemTitle : ''}
								arrow
								placement="top"
							>
								<StyledWrapper.NavLink onClick={() => goToTab(item?.link || item?.id)}>
									{truncateString(itemTitle)}
								</StyledWrapper.NavLink>
							</Tooltip>
						</StyledWrapper.CustomAccordionSummary>

						<AccordionDetails
							id={'accordian-details'}
							sx={{
								display: 'flex',
								width: 'fit-content',
								flexDirection: 'column',
								gap: '5px',
								marginLeft: '20px;'
							}}
						>
							{item?.children?.map((e, index) =>
								e?.forms ? (
									<FormsDropdown
										status={e?.status}
										currentStage={e?.is_current_stage}
										key={`${index}-${e?.title}`}
										isStage={true}
										lastChild={data[1]?.children?.length - 1 === index}
										item={e}
										active={activeLink}
										text={e?.title}
										onClick={goToTab}
									/>
								) : (
									<VerticalNavLink
										status={e?.status}
										currentStage={e?.is_current_stage}
										key={`${index}-${e?.title}`}
										active={
											url.includes(`${item?.id}`) ||
											activeLink === e?.id?.toLowerCase() ||
											activeLink === e?.title?.toLowerCase()
										}
										text={e?.title}
										onClick={(x) => goToTab(e?.link || x)}
										external={false}
									/>
								)
							)}
						</AccordionDetails>
					</StyledWrapper.DropdownContainer>
				) : (
					<VerticalNavLink
						status={item?.status}
						currentStage={item?.is_current_stage}
						active={
							activeLink === item?.id?.toLowerCase() || activeLink === itemTitle.toLowerCase()
						}
						text={item?.title}
						onClick={(e) => goToTab(item?.link || e)}
						mainLink
						external={item?.link.includes('http')}
					/>
				);
			})}
		</StyledWrapper.Container>
	);
};

export default VerticalNavigation;
